import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'
import modifiers from 'src/i18n/modifiers'

export default boot(({ app }) => {
  const i18n = createI18n({
    legacy: false,
    reload: true,
    locale: 'en',
    globalInjection: true,
    messages,
    modifiers,
  })

  // Set i18n instance on app
  app.use(i18n)
})
